import { render, staticRenderFns } from "./impower.vue?vue&type=template&id=bb27f224&scoped=true&"
import script from "./impower.vue?vue&type=script&lang=js&"
export * from "./impower.vue?vue&type=script&lang=js&"
import style0 from "./impower.vue?vue&type=style&index=0&id=bb27f224&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb27f224",
  null
  
)

export default component.exports